export default __webpack_public_path__ + "static/media/it.58e75ceb.svg";